var _defs, _path, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskJoined24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009AD9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TaskJoined_24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,19.28V15H11v4.28a1.91,1.91,0,0,0-.72.72H0v2H10.28a2,2,0,0,0,3.44,0H24V20H13.72A1.91,1.91,0,0,0,13,19.28Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_content_cloud_queue",
    "data-name": "ic/content/cloud_queue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_cloud_queue_24px",
    "data-name": "ic cloud queue 24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "cls-1",
    d: "M19.35,7a7.49,7.49,0,0,0-14-2A6,6,0,0,0,6,17H19a5,5,0,0,0,.35-10ZM19,15H6A4,4,0,0,1,6,7h.71A5.5,5.5,0,0,1,17.5,8.5V9H19a3,3,0,0,1,0,6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskJoined24);
export default __webpack_public_path__ + "static/media/TaskJoined_24.67cd52759d7ea43373eaf31344703a10.svg";
export { ForwardRef as ReactComponent };